module.exports = __webpack_public_path__ + "img/gift-10.04fd3536.jpg";